<div class="ts-badge ts-badge--{{ type }}" [class.floating]="floating" [class.no-overlap]="noOverlap">
  {{ value }}
</div>
